import { useEffect } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import { deploymentName, environment, isProd, isStaging } from 'constants/environment';

const shouldInitDatadog = isStaging || isProd;

const tenantsWithLogs = ['carbonify', 'carbonifyat', 'smartcarb'];

const DatadogInit = ({ tenant }: { tenant: string }) => {
  useEffect(() => {
    if (!shouldInitDatadog || !tenant || !tenantsWithLogs.includes(tenant)) {
      return;
    }

    datadogLogs.init({
      clientToken: 'pubde5911f36f39cb173bb81a812c26fe69',
      site: 'datadoghq.eu',
      forwardConsoleLogs: ['info', 'warn', 'error'],
      forwardErrorsToLogs: true,
      service: 'cb-frontend-landings',
      env: environment,
      version: process.env.NEXT_PUBLIC_APP_VERSION || 'unknown',
      sessionSampleRate: 100,
      telemetrySampleRate: 0,
    });

    datadogLogs.setGlobalContextProperty('deployment', deploymentName);
    datadogLogs.setGlobalContextProperty('tenant', tenant);
  }, [tenant]);

  return null;
};

export default DatadogInit;
